import React, {useEffect} from 'react';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import {useNavigate, useParams} from "react-router-dom";
import {Alert, Stack} from "@mui/material";
import Button from "@mui/material/Button";
import {isValidPassword} from "../components/Register";
import {useResetPasswordMutation} from "../slices/apiSlice";

const ResetPassword = () => {
    const {ruid} = useParams()

    const navigate = useNavigate()

    const [validationErrors,setValidationErrors] = React.useState([])

    const [resetPassword, resetPasswordResult] = useResetPasswordMutation()

    const handleSubmit = (event) => {
        event.preventDefault()

        const data = new FormData(event.currentTarget);
        const password = data.get('password')
        const confirmPassword = data.get('confirmPassword')

        const errors = []

        if (!isValidPassword(password)) {
            errors.push('Please enter a password that is at least 8 characters long')
        }
        else if (!confirmPassword) {
            errors.push('Please confirm your new password')
        }
        else {
            if (password !== confirmPassword) errors.push('Passwords do not match')
        }

        if (errors.length === 0 ) {
            setValidationErrors([])
            resetPassword({
                password:password,
                uuid: ruid
            })
        }
        else {
            setValidationErrors(errors)
        }

    }

    useEffect(() => {
        if (resetPasswordResult.isSuccess) {
            if (resetPasswordResult.data.status === 'ok') {
                navigate('/')
            }
            else {
                console.log("*** error while resetting password")
                console.log(resetPasswordResult.data.error)
            }
        }
    }, [resetPasswordResult]);

    let cnt = 0

    return (
        <Container component="main" maxWidth="xs">
            <Box component="form" onSubmit={handleSubmit} noValidate my={8} sx={{textAlign:'left'}}>
                <Typography variant={'h3'} mb={2}>Please enter your new password</Typography>
                <Stack>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="New password"
                        type="password"
                        id="password"
                    />

                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="confirmPassword"
                        label="Confirm password"
                        type="password"
                        id="confirmPassword"
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Reset password
                    </Button>
                </Stack>
            </Box>
            {validationErrors &&
                validationErrors.map( err =>{
                    return (
                        <Alert  key={++cnt} severity="error" sx={{margin: '0.5em 0 1em 0'}}>
                            {err}
                        </Alert>
                    )
                })
            }
        </Container>
    )
}

export default ResetPassword;